import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import css from './CategoryPicker.css';

const VALID_CATEGORIES = [
    'Ad Networks & DSPs',
    'Affiliate Networks, Offerwalls & Reward Platforms',
    'Analytics & Data Storage',
    'Preload Partner',
    'Retargeting & Re-engagement Platforms',
    'Social & Search Platforms',
    'Third-Party App Stores',
    'Third-Party Payment Platform',
    'SSPs & Mediation Platforms',
    'Campaign Optimization Automation Tools',
    'App Store Intelligence & ASO Tools',
    'Marketing Automation & Customer Engagement Platforms',
];

const CategoryPicker = ({ selected, max, onToggle }) => (
    <div className={css.grid}>
        {VALID_CATEGORIES.map(category => {
            const isSelected = selected.includes(category);
            const isMaxed = !isSelected && selected.length >= max;
            return (
                <button
                    key={category}
                    type="button"
                    className={classNames(css.chip, {
                        [css.chipSelected]: isSelected,
                        [css.chipDisabled]: isMaxed,
                    })}
                    onClick={() => onToggle(category)}
                    disabled={isMaxed}
                >
                    <span className={css.checkbox}>{isSelected && <span className={css.checkmark} />}</span>
                    {category}
                </button>
            );
        })}
    </div>
);

CategoryPicker.propTypes = {
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
    max: PropTypes.number.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default CategoryPicker;
